import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getAsset } from '@/api/aso';

/**
 * A store graphic by content hash. Served through the authorised API, so the
 * bytes live in an object URL rather than a plain <img src>. Hashes never
 * change meaning, hence the long staleTime.
 */
export function AssetImage({ hash, alt, className = '' }: { hash: string | null; alt: string; className?: string }) {
  const [src, setSrc] = useState('');
  const q = useQuery({
    queryKey: ['aso-asset', hash],
    queryFn: () => getAsset(hash!),
    enabled: !!hash,
    staleTime: 60 * 60 * 1000,
  });
  useEffect(() => {
    if (!q.data) return;
    const url = URL.createObjectURL(q.data);
    setSrc(url);
    return () => URL.revokeObjectURL(url);
  }, [q.data]);

  if (!hash) return <div className={`bg-surface-muted ${className}`} aria-label={`${alt} (missing)`} />;
  if (q.isError) return <div className={`flex items-center justify-center bg-danger-soft text-danger text-[10px] ${className}`}>!</div>;
  if (!src) return <div className={`animate-pulse bg-surface-muted ${className}`} aria-label={`Loading ${alt}`} />;
  return <img src={src} alt={alt} className={className} loading="lazy" />;
}
